import React, { useCallback, useEffect } from 'react';

import { atom, useAtom } from 'jotai';

import FullPageLoader from '../../Shared/components/FullPageLoader';

export type RenderingMode = 'react' | 'turbolinksTransition';

const renderingModeAtom = atom<RenderingMode>('react');

function useRenderingMode(): RenderingMode {
  const [renderingMode, setRenderingMode] = useAtom(renderingModeAtom);

  const onTurbolinksClick = useCallback(() => {
    setRenderingMode('turbolinksTransition');
  }, [setRenderingMode]);

  const onTurbolinksVisit = useCallback(() => {
    setRenderingMode('turbolinksTransition');
  }, [setRenderingMode]);

  const onTurbolinksBeforeRender = useCallback(() => {
    setRenderingMode('react');
  }, [setRenderingMode]);

  useEffect(() => {
    window.addEventListener('turbolinks:click', onTurbolinksClick, false);

    // This is a potentially redundant event listener with turbolinks:click
    // but is necessary to handle the case when browser back button is used
    window.addEventListener('turbolinks:visit', onTurbolinksVisit, false);

    window.addEventListener('turbolinks:before-render', onTurbolinksBeforeRender, false);

    return () => {
      window.removeEventListener('turbolinks:click', onTurbolinksClick, false);
      window.removeEventListener('turbolinks:visit', onTurbolinksVisit, false);
      window.removeEventListener('turbolinks:before-render', onTurbolinksBeforeRender, false);
    };
  }, []);
  return renderingMode;
}

const RenderingModeGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const renderingMode = useRenderingMode();
  const isLoadingRailsContent = renderingMode === 'turbolinksTransition';

  if (isLoadingRailsContent) {
    return <FullPageLoader isLoading={true} />;
  }

  return <>{children}</>;
};

export default RenderingModeGuard;
